import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536132b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-full flex items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_3 = { class: "flex mt-1 select-none" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPanel = _resolveComponent("LoadingPanel")!
  const _component_RedText = _resolveComponent("RedText")!

  return (_ctx.problemDescriptionPresenter.isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingPanel)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RedText, {
            border_radius: 0.25,
            class: "mr-3 ml-1",
            padding: 2,
            text: _ctx.problemDescriptionPresenter.problemDescription.value.timeLimit + ' sec',
            textSize: 'text-xs'
          }, null, 8, ["text"]),
          _createVNode(_component_RedText, {
            border_radius: 0.25,
            class: "my-auto",
            padding: 2,
            text: _ctx.problemDescriptionPresenter.problemDescription.value.memoryLimit + ' KB'
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", {
          ref: "problemDomElement",
          class: "mt-4 mb-10 description",
          style: {"user-select":"contain"},
          innerHTML: _ctx.problemDescriptionPresenter.displayedProblemHtml.value
        }, null, 8, _hoisted_4)
      ]))
}